<template lang="pug" src="./history.pug"></template>

<script>
import { mapActions } from 'vuex'
import { mapGetters } from 'vuex'
import { buildPayloadPagination } from '@/utils/utils.js'

export default {
  data () {
    return {
      dataTableLoading: true,
      search: '',
      searchInput: '',
      pagination: {
        identity: window.localStorage.getItem('selectedHotspot').split('"').join(''),
        sortBy: ['campaignName'],
        sortDesc: ['true']
      },
      fieldsToSearch: ['campaignName']
    }
  },
  computed: {
    headers() {
      return [
        { text: `${this.$t('mailHistory.CREATEDAT')}`, value: 'createdAt'},
        { text: `${this.$t('mailHistory.CAMPAINGNAME')}`, value: 'campaignName'},
        { text: `${this.$t('mailHistory.DELIVERED')}`, value: 'delivered' },
        { text: `${this.$t('mailHistory.OPENED')}`, value: 'opened' },
        { text: `${this.$t('mailHistory.SENDED')}`, value: 'sended' },
        { text: `${this.$t('mailHistory.REJECTED')}`, value: 'rejected' },
        { text: `${this.$t('mailHistory.COMPLAINTED')}`, value: 'complainted' },
        { text: `${this.$t('mailHistory.BOUNCED')}`, value: 'bounced'},
        { text: `${this.$t('mailHistory.TOTALEMAILS')}`, value: 'totalEmails'},
      ]
    },
    lang(){
      return this.$store.getters.locale
    },
    items() {
      return this.$store.state.adminMail.mails
    },
    totalItems() {
      return this.$store.state.adminMail.totalMails
    },
    selectedHs () {
      return this.$store.state.adminHotspots.selectedHotspot
    }
  },
  methods: {
    ...mapGetters(['isTokenSet']),
    ...mapActions(['getMailsHistory']),
    async doSearch() {
      this.pagination.identity = window.localStorage.getItem('selectedHotspot').split('"').join('')
      try {
        this.dataTableLoading = true

        await this.getMailsHistory(
          buildPayloadPagination(this.pagination, this.buildSearch())
        )

        this.dataTableLoading = false
        // eslint-disable-next-line no-unused-vars
      } catch (error) {
        this.dataTableLoading = false
      }
    },
    buildSearch() {
      console.log('Search: '+this.search
        ? { query: this.search, fields: this.fieldsToSearch.join(',') }
        : {})
      return this.search
        ? { query: this.search, fields: this.fieldsToSearch.join(',') }
        : {}
    }

  },
  mounted(){
    this.doSearch()
  },
  watch: {
    selectedHs () {
      this.doSearch()
    },
    pagination: {
      async handler() {

        console.log('handler')
        try {
          this.dataTableLoading = false

          await this.getMailsHistory(
            buildPayloadPagination(this.pagination, this.buildSearch())
          )

          this.dataTableLoading = false
          // eslint-disable-next-line no-unused-vars
        } catch (error) {
          this.dataTableLoading = false
        }
      },
      deep: true
    },
    search() {
      clearTimeout(this.delayTimer)
      this.delayTimer = setTimeout(() => {
        this.doSearch()
      }, 400)
    }
  },

}

</script>
